import { render, staticRenderFns } from "./PicCard.vue?vue&type=template&id=cac85d30&scoped=true&"
import script from "./PicCard.vue?vue&type=script&lang=js&"
export * from "./PicCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac85d30",
  null
  
)

export default component.exports